import { Monitor, Download } from 'lucide-react';
import { downloadLatestInstaller, RELEASES_LATEST_URL } from '../marketing/downloadApp';

/**
 * Shown on the web for a capability that requires the desktop app.
 * The Formatter formats/converts local Word files with the local engine, so
 * it is desktop-only; on the web, Word export lives inside Master Specs and
 * Project Specs (server-side engine). Clear, non-broken state + the desktop
 * download — instead of controls that error.
 */
export function DesktopOnlyNotice({
  title = 'The Formatter runs in the desktop app',
  body = 'The Formatter formats and converts Word files on your machine, so it needs the SpecForma desktop app. Everything else works right here on the web — and you can still export Word manuals from Master Specs and Project Specs.',
}: {
  title?: string;
  body?: string;
}) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6 font-sans">
      <div className="max-w-md rounded-xl border border-border bg-surface p-8 text-center shadow-sm">
        <span className="mx-auto flex size-12 items-center justify-center rounded-lg bg-primary-soft text-primary">
          <Monitor className="size-6" aria-hidden="true" />
        </span>
        <h2 className="mt-4 text-xl font-semibold text-text">{title}</h2>
        <p className="mt-2 text-md leading-relaxed text-muted">{body}</p>
        <a
          href={RELEASES_LATEST_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            // Plain clicks download in place; modified clicks keep the
            // releases page via the real href.
            if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0)
              return;
            e.preventDefault();
            void downloadLatestInstaller();
          }}
          className="mt-6 inline-flex items-center justify-center gap-2 rounded-md bg-primary px-5 py-2.5 text-md font-semibold text-inverse transition-colors hover:bg-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <Download className="size-4" aria-hidden="true" />
          Download desktop app (Windows)
        </a>
      </div>
    </div>
  );
}
